<div class="tal-topbar" [class.blur]="isBlurred">
  <div>
    <button [disabled]="disabilita_bottone" type="button" class="tal-square-button" icon="pi pi-plus" pButton pRipple pTooltip="Aggiungi una scheda" (click)="addProject()" styleClass="addTabButton"></button>
    <p-tabMenu [scrollable]="scrollable_prop" [model]="items" [activeItem]="activeItem" styleClass="tabMenu" >
        <ng-template pTemplate="item" let-item >
          <div (click)="setCurrentTab(item)" class="tab">
              {{ item.label }}
              <!-- Ho sostituito il [disabled]="disableDelete" con l'hidden-->
              <!-- <button class="buttonClose" type="button" pButton pRipple icon="pi pi-times" (click)="deleteProject(item.id)" *ngIf="!disableDelete"> </button> -->
            </div>
          </ng-template>
    </p-tabMenu>
  </div>

    <div class="tal-message-box">
        <div #messageBox *ngIf="!!currentNotification" class="tal-message-box-main tal-message-box-{{currentNotification.type}}" >
            <div class="tal-message-col">
                <i class="pi {{iconForNotification()}} tal-message-row tal-message-row-icon"></i>
            </div>
            <div class="tal-message-col">
                <div class="tal-message-row tal-message-row-title">{{currentNotification.title}}</div>
                <div class="tal-message-row tal-message-row-message">{{currentNotification.message}}</div>
            </div>
        </div>
    </div>

    <div class="tal-bar-url">



        <button pButton icon="pi {{changeThemIcon}}" class="tal-square-button" pTooltip="Change theme" (click)="toggleTheme()"></button>
    </div>
    <div class='tutorial'>
      <button pButton pTooltip="Mostra il tutorial" (click)="showTutorial()" class="tal-square-button" icon="pi pi-question-circle" *ngIf=isTutorialButtonVisible></button>
    </div>
</div>

